import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        bannerContainer: {
            w: '100%',
            h: 'auto',
            flexDir: {
                base: 'column-reverse',
                sm: 'column-reverse',
                md: 'column-reverse',
                lg: 'row',
            },
            justifyContent: 'center',
            alignItems: 'center',
            bg: 'background.light-dark',
            paddingY: {
                base: 'small.base',
                lg: 0,
            },
            gap: 'medium.base',
        },
        infoContainer: {
            flexDir: 'column',
            alignItems: {base: 'center', sm: 'center', md: 'center', lg: 'unset'},
            gap: 'large.sm',
            width: {base: '100%', lg: '50%'},
            paddingY: {
                base: 'unset',
                lg: 'large.lg',
            },
        },
        mediaContainer: {
            width: {base: '100%', lg: '50%'},
            justifyContent: {base: 'center', lg: 'flex-start'},
        },

        recipeInfoContainer: {
            flexDir: 'column',
            alignItems: {base: 'flex-start', lg: 'flex-start'},
            gap: 'medium.base',
            alignSelf: 'stretch',
            textAlign: 'start',
        },
        infoTitle: {
            color: 'text.default',
            textAlign: {
                base: 'center',
                lg: 'start',
            },
            alignSelf: 'stretch',
            textStyle: 'head-large',
            fontWeight: 'semibold',
        },
        description: {
            color: 'text.secondary',
            alignSelf: 'stretch',
            textStyle: 'body-small',
            fontWeight: 'normal',
        },
        buttonContainer: {
            flexDir: {
                base: 'column',
                lg: 'row',
            },
            alignItems: {
                base: 'center',
                lg: 'flex-start',
            },
            gap: 'medium.base',
            alignSelf: {base: 'center', sm: 'center', md: 'center', lg: 'flex-start'},
        },
        infoBottomContainer: {
            justifyContent: {base: 'center', sm: 'center', md: 'flex-center', lg: 'flex-start'},
            alignItems: 'center',
            gap: 'medium.base',
            w: '100%',
            maxWidth: {base: remCalc(375), lg: '100%'},
            paddingX: {base: 'small.base', lg: 'unset'},
            flexWrap: {base: 'wrap', lg: 'unset'},
        },
        infoTileContainer: {
            flexDir: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 'small.base',
        },
        infoTileTextContainer: {
            flexDir: 'column',
            gap: 'xxsmall.base',
        },
        infoTileTitle: {
            color: 'text.tertiary',
            textStyle: 'head-xxsmall',
            fontWeight: 'semibold',
        },
        infoTileText: {
            color: 'text.secondary',
            textStyle: 'body-small',
            fontWeight: 'normal',
            minWidth: remCalc(50),
            whiteSpace: 'nowrap',
        },
        infoIcons: {
            color: 'text.tertiary',
            w: 'iconsSize.xlarge',
            h: 'iconsSize.xlarge',
        },
    },
}
